import z from "zod";
/**
 * PatrimonioChecklistMaquinaEquipSchema
 */


export const InspecaoPatrimonioItensSchema = z.object({
  idInspecaoPatrimonioItens: z.number(),
  descricao: z.string().nullable(),
  inspecao1: z.string().default(""),
  dataInspecao1: z.date().nullable().default(null),
  inspecao2: z.string().default(""),
  dataInspecao2: z.date().nullable().default(null),
});

export type InspecaoPatrimonioItensForm = z.infer<typeof InspecaoPatrimonioItensSchema>;


export const InspecaoPatrimonioSchema = z.object({
  idInspecaoPatrimonio: z.number().optional().nullable(),
  idPatrimonioChecklistMaquinaEquip: z.number().optional().nullable(),
  status: z.number().optional().nullable(),
  idFuncionarioAprovado: z.number().optional().nullable(),
  idFuncionarioInspecionado: z.number().optional().nullable(),
  dataInspecao: z.date().optional().nullable(),
  dataEncerramento: z.date().optional().nullable(),
  descricao: z.string().optional().nullable(),
  observacao: z.string().optional().nullable(),
  inspecaoPatrimonioItens: z.array(InspecaoPatrimonioItensSchema).default([]),
  filtrarFuncionariosPorCentroCusto: z.coerce.boolean().default(true),

});

/**
 * PatrimonioChecklistMaquinaEquipForm
 */

export type InspecaoPatrimonioForm = z.infer<typeof InspecaoPatrimonioSchema>;

/**
 * initialPatrimonioChecklistMaquinaEquipForm
 */

export const initialInspecaoPatrimonioForm: Partial<InspecaoPatrimonioForm> = {
  status: 1,
};